export default __webpack_public_path__ + "static/char-s-46-zh-Hant-b2cae42a42337267204ebd106022d08a.webp";